
const reco_partie_1 = `
<p>Trop souvent associée à l’idée de bien et de mal, l’éthique est généralement perçue comme une nouvelle couche de règles contraignantes voire culpabilisantes. L’éthique relève pourtant bien plus d’une approche de réflexion sur le sens d’une action afin de déterminer l’action la plus juste dans des circonstances données.</p>
<p>Du fait des impacts que peuvent avoir les technologies sur les personnes, la société et l’environnement, l’appréhension éthique des technologies et des usages associés s’est peu à peu imposée comme un exercice nécessaire. Des principes éthiques du numérique ont d’ailleurs été identifiés, comme par exemple ceux dégagés pour une « IA de confiance » par le groupe d’expert sur l’intelligence artificielle mis en place par la Commission européenne.</p>
`
const reco_partie_3 = `
<p>Le développement et/ou l’utilisation de technologies impliquent quasi-systématiquement le traitement de données. Lorsque ces données ont un caractère personnel, la conformité à la règlementation applicable en matière de protection des données personnelles est à assurer.</p>
<p>De manière plus large, une gouvernance éthique des données pourra également être à considérer, notamment lorsque le traitement de ces données participera à des recommandations ou décisions algorithmiques pouvant avoir des impacts sur les personnes. Des questions liées, par exemple, à la qualité des données, leur caractère exact et représentatif pourront se poser.</p>
`
const reco_partie_5 = `
<p>Le recours à un système algorithmique d’IA est rarement neutre, surtout en cas d’utilisation d’un système de type « apprentissage machine ».</p>
<p>En effet, plus un système algorithmique présentera des fonctionnalités d’apprentissage, plus il y aura de risques et impacts potentiels à considérer comme, par exemple, l’identification des responsabilités, le risque de biais reproduits par le système, son influence sur la décision humaine (voire son remplacement) ou les modalités de transparence et l’explicabilité du système pour garantir une compréhension humaine.</p>
`

const parties = [
  {
    label: "Approche éthique",
    questions: [1,2,3,4,5,6,7],
    maxScore: 34,
    graph: {
      type: "segment-range"
    },
    evaluations: [
      {
        min: 0,
        max: 33,
        reco: reco_partie_1,
        color: "#bf616a"
      },
      {
        min: 33,
        max: 66,
        reco: reco_partie_1,
        color: "#d08770"
      },
      {
        min: 66,
        max: 100,
        reco: reco_partie_1,
        color: "#a3be8c"
      }
    ]
  },
  {
    label: "Traitement des données personnelles",
    questions: [8],
    maxScore: 5,
    graph: {
      // type: "segment-value"
      type: "segment-range"
    },
    evaluations: [
      {
        min: 0,
        max: 33,
        // reco: `Vous utilisez des données persos, cela pourrait poser problèmes ...`,
        reco: `<p>Lorsque vous traitez des données personnelles, les risques d’atteinte à la vie privée sont à considérer, notamment au regard du caractère intrusif ou du degré de surveillance que la technologie peut entraîner. De plus, la conformité à la réglementation applicable en matière de protection des données personnelles (comme le RGPD et la loi « Informatique & Libertés ») doit être assurée.`,
        color: "#bf616a"
      },
      {
        min: 33,
        max: 66,
        // reco: `Vous utilisez des données persos, cela pourrait poser problèmes ...`,
        reco: `<p>Lorsque vous traitez des données personnelles, les risques d’atteinte à la vie privée sont à considérer, notamment au regard du caractère intrusif ou du degré de surveillance que la technologie peut entraîner. De plus, la conformité à la réglementation applicable en matière de protection des données personnelles (comme le RGPD et la loi « Informatique & Libertés ») doit être assurée.`,
        color: "#d08770"
      },
      {
        min: 66,
        max: 100,
        // reco: `Bravo !! Vous êtes respectueux des données personnelles de vos utilisateurs !`,
        reco: `<p>Dans la mesure où aucune donnée permettant d’identifier directement ou indirectement une personne physique n’est traitée, les risques d’atteinte à la vie privée sont plus limités.</p>`,
        color: "#a3be8c"
      }
    ]
  },
  {
    label: "Gestion des données personnelles",
    questions: [9,10,11,12],
    maxScore: 26,
    graph: {
      type: "segment-range"
    },
    evaluations: [
      {
        min: 0,
        max: 33,
        reco: reco_partie_3,
        color: "#bf616a"
      },
      {
        min: 33,
        max: 66,
        reco: reco_partie_3,
        color: "#d08770"
      },
      {
        min: 66,
        max: 100,
        reco: reco_partie_3,
        color: "#a3be8c"
      }
    ]
  },
  {
    label: "Recours à un système algorithmique (IA)",
    questions: [13],
    maxScore: 5,
    graph: {
      // type: "segment-value"
      type: "segment-range"
    },
    evaluations: [
      {
        min: 0,
        max: 33,
        // reco: `Des efforts à faire...`,
        reco: `<p>Des risques et enjeux particuliers peuvent être associés au recours à un système algorithmique dit d’« intelligence artificielle ».</p>`,
        color: "#bf616a"
      },
      {
        min: 33,
        max: 66,
        // reco: `Des efforts à faire...`,
        reco: `<p>Des risques et enjeux particuliers peuvent être associés au recours à un système algorithmique dit d’« intelligence artificielle ».</p>`,
        color: "#d08770"
      },
      {
        min: 66,
        max: 100,
        reco: `<p>Aucun système algorithmique n’est utilisé. Les risques et enjeux pouvant être associés aux systèmes dits d’« intelligence artificielle » (notamment de type « apprentissage machine ») comme, par exemple, le risque de biais reproduits par le système, la transparence et l’explicabilité du système ou l’évaluation de son impact sur la décision humaine, n’ont donc pas vocation à être considérés.</p>`,
        color: "#a3be8c"
      }
    ]
  },
  {
    label: "Traitement algorithmique (IA)",
    questions: [14,15,16,17,18,19],
    maxScore: 25,
    graph: {
      type: "segment-range"
    },
    evaluations: [
      {
        min: 0,
        max: 33,
        reco: reco_partie_5,
        color: "#bf616a"
      },
      {
        min: 33,
        max: 66,
        reco: reco_partie_5,
        color: "#d08770"
      },
      {
        min: 66,
        max: 100,
        reco: reco_partie_5,
        color: "#a3be8c"
      }
    ]
  },
  {
    label: "Redevabilité",
    questions: [20],
    maxScore: 5,
    graph: {
      // type: "segment-value"
      type: "segment-range"
    },
    evaluations: [
      {
        min: 0,
        max: 33,
        reco: `<p>Le principe de redevabilité (« accountability ») relève de la capacité à pouvoir « rendre des comptes ». Dans le cadre de l’éthique du numérique, sa mise en œuvre permet d’informer, d’expliquer et de justifier ses actions et technologies développées et/ou utilisées auprès des personnes concernées mais également de la société dans son ensemble. La redevabilité implique donc des actions concrètes, sur la durée.</p>`,
        color: "#bf616a"
      },
      {
        min: 33,
        max: 66,
        reco: `<p>Le principe de redevabilité (« accountability ») relève de la capacité à pouvoir « rendre des comptes ». Dans le cadre de l’éthique du numérique, sa mise en œuvre permet d’informer, d’expliquer et de justifier ses actions et technologies développées et/ou utilisées auprès des personnes concernées mais également de la société dans son ensemble. La redevabilité implique donc des actions concrètes, sur la durée.</p>`,
        color: "#d08770"
      },
      {
        min: 66,
        max: 100,
        reco: `<p>Le principe de redevabilité (« accountability ») relève de la capacité à pouvoir « rendre des comptes ». Dans le cadre de l’éthique du numérique, sa mise en œuvre permet d’informer, d’expliquer et de justifier ses actions et technologies développées et/ou utilisées auprès des personnes concernées mais également de la société dans son ensemble. En allant au-delà du simple déclaratif, vous avez mis en œuvre des actions concrètes. Une approche éthique, c’est en effet agir sur la durée.</p>`,
        color: "#a3be8c"
      }
    ]
  }
]

const questionnaire = {
  title: "Questionnaire éthique et numérique",
  id: "evaluation",
  description: `<h2>Testez-vous sur l’éthique et le numérique !</h2>
  <p>Explorez comment vos pratiques peuvent s’inscrire dans le cadre d’une démarche éthique appliquée au numérique en répondant à un petit questionnaire concocté par Babotics :)</p>
  <p>Ce questionnaire n’a pas vocation à vous fournir une analyse précise et détaillée de votre situation et ne saurait en aucun cas constituer une évaluation spécifique, personnalisée et opposable de vos risques par rapport à vos activités.</p>
  <p>Il s’agit ici d’aborder de manière ludique quelques questions et risques pouvant être à considérer lorsqu’une approche éthique est envisagée pour le développement et/ou l’utilisation de technologies.</p>`,
  // "#bf616a", "#d08770", "#ebcb8b", "#a3be8c"
  // "#bf616a", "#c3785e", "#bc915e", "#b0a96f", "#a3be8c"
  
  evaluations: [
    {
      min: 0,
      max: 33,
      reco: `<h3>Osez l’approche éthique du numérique !</h3>
      <p>L’éthique appliquée au numérique permet d’évaluer et de mettre en perspective le sens et les impacts de ses projets de développement et d’utilisation de technologies. Intégrer une démarche éthique peut représenter une réelle valeur ajoutée, en limitant ses risques et en renforçant la confiance de ses clients et/ou usagers ainsi que l’acceptabilité de ses activités, services et produits sur le long terme.</p>
      <p>Cela passe par des actions concrètes qui peuvent prendre diverses formes (définition et documentation de ses orientations stratégiques en matière d’innovation responsable, formation, gouvernance, études d’impacts, etc.).</p>
      <p>Lancez-vous et n’hésitez pas à adopter une approche « petits pas » en commençant sur la base d’un cas d’usage par exemple.</p>
      <p>Et bien sûr, si vous souhaitez en savoir plus et être accompagné dans cette démarche, n’hésitez pas à nous contacter : <a href="mailto:contact@babotics.com">contact@babotics.com</a></p>`,
      color: "#bf616a"
      // color: "#20366a"
    },
    {
      min: 33,
      max: 66,
      reco: `<h3>Continuez sur votre lancée !</h3>
      <p>L’éthique appliquée au numérique permet d’évaluer et de mettre en perspective le sens et les impacts de ses projets de développement et d’utilisation de technologies. Intégrer une démarche éthique peut représenter une réelle valeur ajoutée, en limitant ses risques et en renforçant la confiance de ses clients et/ou usagers ainsi que l’acceptabilité de ses activités, services et produits sur le long terme.</p>
      <p>Cela passe par des actions concrètes qui peuvent prendre diverses formes (définition et documentation de ses orientations stratégiques en matière d’innovation responsable, formation, gouvernance, études d’impacts, etc.). </p>
      <p>Continuez sur votre lancée et n’hésitez pas à adopter une approche « petits pas » en commençant sur la base d’un cas d’usage par exemple.</p>
      <p>Et bien sûr, si vous souhaitez en savoir plus et être accompagné dans cette démarche, n’hésitez pas à nous contacter : <a href="mailto:contact@babotics.com">contact@babotics.com</a></p>`,
      color: "#d08770"
      // color: "#2b4a91"
    },
    {
      min: 66,
      max: 100,
      reco: `<h3>Vous assurez :)</h3>
      <p>Vous vous inscrivez dans une démarche éthique appliquée au numérique qui vous permet d’évaluer et de mettre en perspective le sens et les impacts de vos projets de développement et d’utilisation de technologies. </p>
      <p>Vous avez bien compris qu’intégrer une démarche éthique peut représenter une réelle valeur ajoutée, en limitant ses risques et en renforçant la confiance de ses clients et/ou usagers ainsi que l’acceptabilité de ses activités, services et produits sur le long terme.</p>
      <p>Cela passe par des actions concrètes qui peuvent prendre diverses formes (définition et documentation de ses orientations stratégiques en matière d’innovation responsable, formation, gouvernance, études d’impacts, etc.). </p>
      <p>Continuez sur votre lancée !</p>
      <p>Et bien sûr, si vous souhaitez en savoir plus et être accompagné dans cette démarche, n’hésitez pas à nous contacter : <a href="mailto:contact@babotics.com">contact@babotics.com</a></p>`,
      color: "#a3be8c"
      // color: "#567acd"
    }
  ],
  questions: [
    {
      id: 1,
      label:
        "Avez-vous identifié précisément le ou les cas d’usage pour la technologie développée ou en cours de développement ?",
      type: "bool",
      choices: [
        {
          id: 1,
          label: "OUI",
          score: 5,
          goto: 2
        },
        {
          id: 2,
          label: "NON",
          score: 0,
          goto: 2
        }
      ]
    },
    {
      id: 2,
      label:
        "Avez-vous identifié les parties prenantes (personnes, communautés, organisations) pouvant être affectées directement ou indirectement par la technologie développée ou en cours de développement ?",
      type: "bool",
      choices: [
        {
          id: 1,
          label: "OUI",
          score: 5,
          goto: 3
        },
        {
          id: 2,
          label: "NON",
          score: 0,
          goto: 4
        }
      ]
    },
    {
      id: 3,
      label:
        "Avez-vous rencontré les parties prenantes (ou leurs représentants) pour évaluer avec elles l’acceptabilité de la technologie développée ou en cours de développement au regard des valeurs qu’elles considèrent essentielles ?",
      type: "bool",
      optional: true,
      choices: [
        {
          id: 1,
          label: "OUI",
          score: 5,
          goto: 4
        },
        {
          id: 2,
          label: "NON",
          score: 0,
          goto: 4
        }
      ]
    },
    {
      id: 4,
      label:
        "Avez-vous impliqué, dès le stade du développement de la technologie, une équipe :",
      type: "multi",
      choices: [
        {
          id: 1,
          label: "Pluridisciplinaire",
          score: 1
        },
        {
          id: 2,
          label: "Diverse (parité hommes/femmes notamment)",
          score: 1
        },
        {
          id: 3,
          label: "Ni l’un, ni l’autre",
          score: 0,
          cb: "reset"
        }
      ]
    },
    {
      id: 5,
      label:
        "Avez-vous pris en compte un ou plusieurs des principes éthiques suivants dès le stade du développement de la technologie ?",
      type: "multi",
      choices: [
        {
          id: 1,
          label: "Dignité",
          score: 1
        },
        {
          id: 2,
          label: "Bien-être",
          score: 1
        },
        {
          id: 3,
          label: "Respect de la vie privée",
          score: 1
        },
        {
          id: 4,
          label: "Autonomie",
          score: 1
        },
        {
          id: 5,
          label: "Équité et justice",
          score: 1
        },
        {
          id: 6,
          label: "Transparence",
          score: 1
        },
        {
          id: 7,
          label: "Redevabilité",
          score: 1
        },
        {
          id: 8,
          label: "Aucun",
          score: 0,
          cb: "reset"
        }
      ]
    },
    {
      id: 6,
      label:
        "Avez-vous évalué et/ou pris en compte l’impact environnemental de la technologie développée ou en cours de développement (ex. matières et ressources utilisées pour la fabrication de matériels, durée de vie de la technologie, réparabilité, consommation énergétique pour l’hébergement de données, etc.) ?",
      type: "bool",
      choices: [
        {
          id: 1,
          label: "OUI",
          score: 5,
          goto: 7
        },
        {
          id: 2,
          label: "NON",
          score: 0,
          goto: 7
        }
      ]
    },
    {
      id: 7,
      label:
        "La technologie développée ou en cours de développement a-t-elle un impact concret positif sur les personnes et/ou la société dans son ensemble (ex. meilleure protection de la vie privée, promotion de la santé pour tous, développement d’énergies durables et à coûts réduits, etc.) ?",
      type: "bool",
      choices: [
        {
          id: 1,
          label: "OUI",
          score: 5,
          goto: 8
        },
        {
          id: 2,
          label: "NON",
          score: 0,
          goto: 8
        }
      ]
    },
    {
      id: 8,
      label:
        "La technologie développée ou en cours de développement implique t’elle le traitement de données à caractère personnel ?",
      type: "bool",
      choices: [
        {
          id: 1,
          label: "OUI",
          score: 0,
          goto: 9
        },
        {
          id: 2,
          label: "NON",
          score: 5,
          goto: 13
        }
      ]
    },
    {
      id: 9,
      label:
        "Avez-vous mis en place au sein de votre organisation, dès le stade du développement de la technologie, une gouvernance permettant de :",
      type: "multi",
      optional: true,
      choices: [
        {
          id: 1,
          label: "Identifier l’origine et les sources des données",
          score: 1
        },
        {
          id: 2,
          label:
            "Garantir avoir les droits nécessaires pour traiter des données",
          score: 1
        },
        {
          id: 3,
          label: "Garantir la fiabilité des données",
          score: 1
        },
        {
          id: 4,
          label:
            "Garantir l’exactitude des données (exactes, à jour et complètes)",
          score: 1
        },
        {
          id: 5,
          label:
            "Minimiser le traitement des données (strictement nécessaires au cas d’usage identifié)",
          score: 1
        },
        {
          id: 6,
          label:
            "Assurer la représentativité des données (au regard des cas d’usage envisagés et des parties prenantes pouvant être affectées)",
          score: 1
        },
        {
          id: 7,
          label: "Aucune gouvernance particulière",
          score: 0,
          cb: "reset"
        }
      ]
    },
    {
      id: 10,
      label:
        "Avez-vous informé les parties prenantes de la façon dont les données sont traitées (collectées, stockées, partagées, utilisées) ?",
      type: "bool",
      optional: true,
      choices: [
        {
          id: 1,
          label: "OUI",
          score: 5,
          goto: 11
        },
        {
          id: 2,
          label: "NON",
          score: 0,
          goto: 11
        }
      ]
    },
    {
      id: 11,
      label:
        "Avez-vous obtenu le consentement des parties prenantes pour le traitement de leurs données ?",
      type: "bool",
      optional: true,
      choices: [
        {
          id: 1,
          label: "OUI",
          score: 5,
          goto: 12
        },
        {
          id: 2,
          label: "NON",
          score: 0,
          goto: 12
        }
      ]
    },
    {
      id: 12,
      label:
        "Avez-vous intégré des mesures de protection de la vie privée au design de la technologie développée ou en cours de développement (ex. chiffrement, opt-in, minimisation des données, etc.) ?",
      type: "bool",
      optional: true,
      choices: [
        {
          id: 1,
          label: "OUI",
          score: 5,
          goto: 13
        },
        {
          id: 2,
          label: "NON",
          score: 0,
          goto: 13
        }
      ]
    },
    {
      id: 13,
      label:
        "La technologie développée ou en cours de développement implique t’elle le recours à un système algorithmique (IA) ?",
      type: "bool",
      choices: [
        {
          id: 1,
          label: "OUI",
          score: 0,
          goto: 14
        },
        {
          id: 2,
          label: "NON",
          score: 5,
          goto: 20
        }
      ]
    },
    {
      id: 14,
      label:
        "Le système algorithmique utilisé est-il un système auto-apprenant (apprentissage machine ou « machine learning ») ?",
      type: "bool",
      choices: [
        {
          id: 1,
          label: "OUI",
          score: 0,
          goto: 15
        },
        {
          id: 2,
          label: "NON",
          score: 5,
          goto: 15
        }
      ]
    },
    {
      id: 15,
      label:
        "Avez-vous mis en place un processus de gouvernance pour assurer la qualité des données traitées par le système (origine, exactitude, représentativité, etc.) ?",
      type: "bool",
      choices: [
        {
          id: 1,
          label: "OUI",
          score: 5,
          goto: 16
        },
        {
          id: 2,
          label: "NON",
          score: 0,
          goto: 16
        }
      ]
    },
    {
      id: 16,
      label:
        "Le système algorithmique a-t-il pour objectif de remplacer la décision humaine ?",
      type: "bool",
      choices: [
        {
          id: 1,
          label: "OUI",
          score: 0,
          goto: 17
        },
        {
          id: 2,
          label: "NON",
          score: 5,
          goto: 17
        }
      ]
    },
    {
      id: 17,
      label:
        "Êtes-vous en mesure de comprendre et d’expliquer pourquoi et comment les résultats sont proposés par le système algorithmique ?",
      type: "bool",
      choices: [
        {
          id: 1,
          label: "OUI",
          score: 5,
          goto: 18
        },
        {
          id: 2,
          label: "NON",
          score: 0,
          goto: 18
        }
      ]
    },
    {
      id: 18,
      label:
        "Avez-vous prévu l’information des utilisateurs et/ou personnes affectées par la technologie sur la logique et la façon dont fonctionne le système algorithmique (ex. catégories de données entrantes, critères et pondération, etc.) ?",
      type: "bool",
      choices: [
        {
          id: 1,
          label: "OUI",
          score: 5,
          goto: 19
        },
        {
          id: 2,
          label: "NON",
          score: 0,
          goto: 19
        }
      ]
    },
    {
      id: 19,
      label:
        "Avez-vous prévu une procédure simple et accessible permettant aux utilisateurs et/ou personnes affectées de :",
      type: "multi",
      choices: [
        {
          id: 1,
          label:
            "Être informés des modalités de fonctionnement du système algorithmique ?",
          score: 1
        },
        {
          id: 2,
          label: "Refuser le recours au traitement algorithmique ?",
          score: 1
        },
        {
          id: 3,
          label: "Contester le recours au traitement algorithmique ?",
          score: 1
        },
        {
          id: 4,
          label: "Bénéficier d’une alternative au traitement algorithmique ?",
          score: 1
        },
        {
          id: 5,
          label: "Bénéficier d’une intervention humaine ?",
          score: 1
        },
        {
          id: 6,
          label: "Aucune procédure",
          score: 0,
          cb: "reset"
        }
      ]
    },
    {
      id: 20,
      label:
        "Êtes-vous en mesure de démontrer les affirmations validées précédemment (ex. actions concrètes engagées, mesures de gouvernance, documentation, etc.) ?",
      type: "bool",
      choices: [
        {
          id: 1,
          label: "OUI",
          score: 5,
          goto: 20
        },
        {
          id: 2,
          label: "NON",
          score: 0,
          goto: 20
        }
      ]
    }
  ]
}

export { questionnaire, parties }
